import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  saveButton: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
  pageContainer: {
    backgroundColor: '#f4f6f8',
  },
  pageItem: {
    marginBottom: 24,
    backgroundColor: '#fff',
  },
  loanBorrowerWrapper: {
    marginBottom: '-20px',
  },
});

export default useStyles;
